import { Grid } from "@mui/material";
import { useLocation } from "react-router-dom";
import { LanguagesDropdown } from "../../../../components/LanguagesDropdown";
import { LogoutButton } from "../../../../components/LogoutButton/LogoutButton.view";
import { MADERA_BACKOFFICE_PATHS } from "constants/constants";
import { useStyles } from "./MBONavbar.styles";

const maderaLoginPath = `/${MADERA_BACKOFFICE_PATHS.ROOT_PATH}/${MADERA_BACKOFFICE_PATHS.LOGIN}`;

export const MBONavbar = () => {
    const classes = useStyles();
    const { pathname } = useLocation();
    const isLoginPage = pathname === maderaLoginPath || pathname === `${maderaLoginPath}/`;

    return (
        <Grid container className={classes.gridBoxShadow}>
            <Grid className={classes.gridContainer}>
                <Grid item className={classes.leftGrid} xs={6}>
                    <LanguagesDropdown />
                </Grid>
                <Grid item className={classes.rightGrid} xs={6}>
                    {!isLoginPage && <LogoutButton loginPath={maderaLoginPath} />}
                </Grid>
            </Grid>
        </Grid>
    );
};
